import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownList from './DropdownList';
import {
  getIp,
  getLocationUsingCoordinates
} from '../../../services/Api/SearchBar/SearchBarService';
import '../../../stylesheets/components/SearchDropdown.scss';
import '../../../stylesheets/components/DropdownList.scss';
import { withTranslation } from 'react-i18next';
import { INTELLIMIZE_SEARCH_MENU_DRUG_CLICK } from '../../../constants/defaults';
import _ from 'lodash';

class SearchDropdown extends Component {
  state = {
    list: {}
  };

  checkIsActive(item, id) {
    return id === 0;
  }

  handleSubmit = (submitId, key = '', searchType = '') => {
    _.sendIntellimizeEvent(INTELLIMIZE_SEARCH_MENU_DRUG_CLICK);
    this.props.handleSubmit(submitId, key, searchType);
  };

  handleIp = () => {
    getIp().then(res => {
      this.props.handleIp(res);
    });
  };

  handleLocation = location => {
    this.props.handleLocation(location);
  };

  useMyCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.showPosition,
        this.blockLocation
      );
    }
  }

  blockLocation = async () => {
    this.handleIp();
  };

  showPosition = async position => {
    const coordinates = {
      latitude: position.coords.latitude, //37.649190399999995,
      longitude: position.coords.longitude //-121.8962375
    };
    const location = await getLocationUsingCoordinates(coordinates);
    if (location) {
      this.handleLocation(location);
    }
  };

  render() {
    const { setSubmitId, submitId, t } = this.props;
    return (
      <div className="site-search-note-error ">
        <div className="site-search-results">
          {this.props.locationDropdown && (
            <div
              id="zipOptions"
              data-mp-text="Location search (ZIP code)"
              className="site-search-results--loc"
            >
              <ul className="sc-nearme-dropdown">
                <li>
                  <a
                    data-mp-text="Use my current location link"
                    className="location-btn"
                    onClick={this.useMyCurrentLocation.bind(this)}
                  >
                    {t('Use my current location')}
                  </a>
                </li>
              </ul>
            </div>
          )}
          {this.props.drugSuggestionDropdown && (
            <div
              id="search-results"
              aria-haspopup="listbox"
              className={`site-search-results--query ${
                this.props.homePage && 'home-result'
              }`}
            >
              <DropdownList
                itemList={this.props.listItems}
                handleSubmit={this.handleSubmit}
                showPopularTitle={this.props.isPopular}
                setSubmitId={setSubmitId}
                submitId={submitId}
              />
            </div>
          )}
          {this.props.invalidLocation && (
            <div className="site-search-form--location invalid">
              <div
                id="zipOptions"
                data-mp-text="Location search (ZIP code)"
                className="site-search-results--loc "
              >
                <ul className="sc-nearme-dropdown">
                  <li className="note-error">
                    <span>{t('The location you entered is not valid.')}</span>
                  </li>
                </ul>
              </div>
            </div>
          )}

          {this.props.noDrugFound && (
            <div
              id="site-search-results"
              className={`site-search-results--query ${
                this.props.homePage && 'home-result'
              }`}
            >
              <article>
                <ul>
                  <li className="note-error">
                    <span className="note" id="drugNameError">
                      {t('Please enter a valid drug name')}
                    </span>
                  </li>
                </ul>
              </article>
            </div>
          )}
        </div>
      </div>
    );
  }
}
SearchDropdown.propTypes = {
  listItems: PropTypes.array,
  drugSuggestionDropdown: PropTypes.bool,
  locationDropdown: PropTypes.bool,
  noDrugFound: PropTypes.bool,
  drug: PropTypes.string,
  invalidLocation: PropTypes.bool,
  isPopular: PropTypes.bool,
  homePage: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleLocation: PropTypes.func,
  handleIp: PropTypes.func,
  setSubmitId: PropTypes.func,
  submitId: PropTypes.number
};

SearchDropdown.defaultProps = {
  listItems: [],
  drugSuggestionDropdown: false,
  locationDropdown: false,
  noDrugFound: false,
  drug: '',
  invalidLocation: false,
  isPopular: false,
  homePage: false,
  handleSubmit: () => {},
  handleLocation: () => {},
  handleIp: () => {},
  setSubmitId: () => {},
  submitId: 0
};
export default withTranslation()(SearchDropdown);
